var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_32845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9701 28.415C27.9701 29.0709 27.737 29.3006 27.0745 29.3006C21.4482 29.3006 15.8186 29.3006 10.1923 29.3006C9.5997 29.3006 9.34668 29.0509 9.34668 28.465C9.34668 21.0443 9.34668 13.6235 9.34668 6.20281C9.34668 5.61688 9.5997 5.36719 10.1923 5.36719C15.8352 5.36719 21.4815 5.36719 27.1245 5.36719C27.7237 5.36719 27.9701 5.61688 27.9701 6.22611C27.9701 9.93148 27.9701 24.723 27.9701 28.415Z",
    fill: "#091E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.97 10.0371H14.0774V25.1515H27.97V10.0371Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9699 13.5773H24.3145V12.1191H27.9699V13.5773ZM27.9699 15.0588H24.3145V16.5136H27.9699V15.0588ZM27.9699 17.9518H24.3079V19.4067H27.9699V17.9518ZM27.9699 20.8915H24.3079V22.3464H27.9699V20.8915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8493 12.1191C17.6729 12.1191 17.5031 12.1891 17.3766 12.3156L16.4311 13.261C16.1714 13.5207 16.1714 13.9435 16.4311 14.2065L19.0978 16.8765L21.7677 14.2065C22.0274 13.9469 22.0274 13.5241 21.7677 13.261L20.8223 12.3156C20.6991 12.1891 20.5293 12.1191 20.3495 12.1191C20.1731 12.1191 20 12.1891 19.8768 12.3156L19.1011 13.0913L18.3221 12.3122C18.1955 12.1924 18.0258 12.1191 17.8493 12.1191Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4212 4.14258H12.8989V5.36771H24.4212V4.14258Z",
    fill: "#204A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6749 4.14211H12.3329C11.9101 4.14211 11.8335 4.06554 11.8335 3.63608C11.8335 2.30441 11.8335 2.31107 11.8335 0.979401C11.8335 0.593217 11.9267 0.5 12.3129 0.5H24.9937C25.3866 0.5 25.4798 0.589888 25.4798 0.969413C25.4798 2.31773 25.4798 2.32772 25.4798 3.67603C25.4798 4.0489 25.3866 4.13878 25.0137 4.13878C22.903 4.14211 20.789 4.14211 18.6749 4.14211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3813 23.672C15.0529 20.3827 11.311 18.7947 8.02173 20.1197C4.73251 21.4481 3.14117 25.1901 4.46951 28.4793C5.79785 31.7685 9.53984 33.3599 12.8291 32.0315C16.1183 30.7032 17.7096 26.9612 16.3813 23.672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0588 23.0918C13.0588 23.0918 9.29013 23.2682 7.9518 24.8762C7.18942 25.7918 7.15946 27.1001 7.27598 28.0556L10.8315 25.5887L7.63886 29.3107C8.18484 29.3307 10.765 29.3506 11.9568 27.9191C13.2951 26.3111 13.0588 23.0918 13.0588 23.0918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_32845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.97,
    height: 32,
    fill: "white",
    transform: "translate(4 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventry);
export default __webpack_public_path__ + "static/media/inventry.eb151c0f4d87f7661090c719a215cf06.svg";
export { ForwardRef as ReactComponent };